const baseURL = "/v1/Instituicao";

const service = {
  methods: {
    $buscarInstituicoes(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $buscarDadosInstituicao({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarInstituicao(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarInstituicao(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarInstituicao(body, id) {
      return this.$api().patch(`${baseURL}/${id}`, body);
    }
  },
};

export default service;
